import { Platform, ViewStyle } from "react-native"

export const isWeb = (): boolean => {
  return Platform.OS === "web"
}

export const getWebFixedWidthStyle = (width: number = 480): ViewStyle => {
  if (!isWeb()) return {}

  return {
    maxWidth: width,
    width: "100%",
    alignSelf: "center" as const,
    marginLeft: "auto" as any,
    marginRight: "auto" as any,
  }
}

export const webStyles = <T>(webStyle: T, nativeStyle?: T): T | {} => {
  return isWeb() ? webStyle : nativeStyle || {}
}
